<template>
  <div class="trem_content">
    <div class="term_box">
      <div class="term_text"
           v-html="content">
      </div>
    </div>
    <p class="tip clearfix">
      <span class="prav_btn fl">
        <span class="Checkbox "
              :class="[checkboxFlog?'Checkbox_active':'']"
              @click="checkbox()"></span>
      </span>
      {{ agreementName }}
      <!-- <span class="fl"> -->
      <!-- {{ $t('logoff.agreementTips') }} -->
      <!-- </span> -->
    </p>
    <!-- <router-link to="/safetyVerification"></router-link> -->
    <div :class="[checkboxFlog?'gotoNext_active':'gotoNext']"
         @click="gotoagreement()">{{ $t('logoff.logoffTipsBtn') }}</div>
  </div>
</template>

<script>
import { del_user_submit, get_game_all, agreement } from '@/api/init'
import { appPostMessage } from '@/utils/communication'
import { getSessionStorage, setSessionStorage } from '../../utils/stage'
export default {
  data() {
    return {
      tipsName: '',
      tipsFlag: false,
      linkUrl: '/',
      accountInfo: '',
      text1: this.$t('logoff.text1'),
      configData: '',
      flag: false,
      content: '',
      checkboxFlog: false,
      agreementName: '',
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.configData = JSON.parse(getSessionStorage('message'))
      const msg = Object.assign(JSON.parse(JSON.stringify(this.configData)), {
        type: 6,
      })
      agreement(msg)
        .then((res) => {
          this.content = this.place(res.data.content)
          if (this.content) {
            //   this.agreementName = this.content
            //     .match(/<p>([\s\S]*?)<\/p>/g)[0]
            //     .replace(/<p>/g, '')
            //     .replace(/<\/p>/g, '')
          }
        })
        .then(() => {
          const name1 = document.getElementsByTagName('p')[0].innerHTML
          //   console.log('name1', document.getElementsByTagName('p')[0].innerHTML)
          this.agreementName = this.$t('logoff.agreementTips').replace(
            '{name}',
            name1
          )
          console.log(
            ' this.agreementName',
            this.agreementName,
            this.$t('logoff.agreementTips')
          )
        })
      this.getInfo(1)
    },
    close() {
      this.tipsFlag = false
    },
    checkbox() {
      this.checkboxFlog = !this.checkboxFlog
    },
    close1() {
      this.tipsFlag = false
      this.$router.push('/home')
    },
    golink() {
      this.tipsFlag = false
    },
    getInfo(pageNum) {
      const access_token = JSON.parse(
        getSessionStorage('accountStorage')
      ).access_token
      const msg = Object.assign(JSON.parse(JSON.stringify(this.configData)), {
        access_token: access_token,
      })
      get_game_all(msg).then((res) => {
        if (res.data.totalPage == 0) {
        } else {
          setSessionStorage('guestRole', JSON.stringify(res.data.list[0]))
        }
      })
    },
    gotoagreement() {
      if (!this.checkboxFlog) {
        return
      }
      const access_token = JSON.parse(
        getSessionStorage('accountStorage')
      ).access_token
      const msg = Object.assign(JSON.parse(JSON.stringify(this.configData)), {
        access_token: access_token,
      })
      if (this.flag) {
        return
      }
      this.flag = true
      del_user_submit(msg).then((res) => {
        this.$router.push('/touristLogoffTips1')
        this.closeBtn()
      })
      setTimeout(() => {
        this.flag = false
      }, 2000)
    },
    closeBtn() {
      const appmsg = { code: 18, data: '' }
      appPostMessage(appmsg)
    },
    placechange(data) {
      const content = data
        .replace(/<e>/g, '<div  style="width:100%;text-align:center;">')
        .replace(/<\/e>/g, '</div>')
        .replace(/<dt>/g, '<a>')
        .replace(/<\/dt>/g, '</a>')
        .replace(/<red>/g, '<span style="color:red;">')
        .replace(/<\/red>/g, '</span>')
        .replace(/<b>/g, '<stong style=" font-weight: 700;color:#575757;">')
        .replace(/<\/b>/g, '</stong>')
        .replace(/\n/g, '</br>')
      return content
    },
    regplace(data) {
      let dataMsg = data
      let dataArr = []
      var n = dataMsg.match(/<dt>([\s\S]*?)<\/dt><dd>([\s\S]*?)<\/dd>/g)
      for (const i in n) {
        const a = n[i].match(/<dt>([\s\S]*?)<\/dt>/)
        const b = n[i].match(/<dd>([\s\S]*?)<\/dd>/)
        const ahmtr = `<a href="#/agreementInfo?text=${i}" style="text-decoration:underline;color:blue;">${a[1]} </a>`
        dataMsg = dataMsg.replace(a[0], ahmtr)
        dataMsg = dataMsg.replace(b[0], '')
        const arr = {
          name: a[1],
          value: b[1],
        }
        dataArr.push(arr)
      }
      return dataMsg
    },
    place(data) {
      const regplaceData = this.regplace(data)
      const content_string = this.placechange(regplaceData)
      return content_string
    },
  },
}
</script>

<style lang="less" scope>
.trem_content {
  width: 100%;
  height: 100%;
  padding: 30/75rem;
  box-sizing: border-box;
  position: relative;
}
.term_box {
  width: 100%;
  height: 66vh;
  overflow: hidden;
  overflow-y: auto;
  padding-bottom: 30/75rem;
  .term_text {
    font-size: 28/75rem;
  }
}
.tip {
  width: 690/75rem;
  font-size: 24 /75rem;
  text-align: left;
  margin: 0 auto;
  //   margin-top: 30 /75rem;
  //   margin-bottom: 27 /75rem;
  color: #959595;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 160/75rem;

  a {
    color: #ff7391;
    text-decoration: underline;
  }
  .prav_btn {
    display: inline-block;
    margin-right: 10 /75rem;
    position: relative;
    margin-top: 5 /75rem;
    width: 28 /75rem;
    height: 28 /75rem;
    .Checkbox {
      display: inline-block;
      width: 28 /75rem;
      height: 28 /75rem;
      background: url('../../assets/images/no.png') no-repeat;
      background-size: contain;
      cursor: pointer;
    }
    .Checkbox_active {
      width: 28 /75rem;
      height: 28 /75rem;
      background: url('../../assets/images/yes.png') no-repeat;
      background-size: contain;
      cursor: pointer;
    }
  }
}
.gotoNext {
  width: 690/75rem;
  height: 76/75rem;
  background: #cfcfcf;
  border-radius: 6/75rem 6/75rem 6/75rem 6/75rem;
  color: #575757;
  text-align: center;
  line-height: 76/75rem;
  font-size: 30/75rem;
  margin: 0 auto;
  position: absolute;
  bottom: 60/75rem;
  left: 0;
  right: 0;
}
.gotoNext_active {
  width: 690/75rem;
  height: 76/75rem;
  background: #ff7391;
  border-radius: 6/75rem 6/75rem 6/75rem 6/75rem;
  color: #fff;
  text-align: center;
  line-height: 76/75rem;
  font-size: 30/75rem;
  margin: 0 auto;
  position: absolute;
  bottom: 60/75rem;
  left: 0;
  right: 0;
}
</style>